import React from "react";

const PerPageSelector = ({ handlePerPageChange, perPage, options }) => {
  const perPageOptions = options && options.length > 0 ? options : [10, 20, 30, 40, 50];
  return (
    <div className="flex border w-fit border-[#E0E2E5] rounded-lg text-[12px]">
      <h2 className="text-[#C1C4CB] py-[4px] px-[8px] border-r border-[#E0E2E5]">
        Per Page
      </h2>
      <select
        className="w-[64px] rounded-lg focus:outline-none mx-[8px]"
        name="perPage"
        id="perPage"
        onChange={handlePerPageChange}
        value={perPage}
      >
        {perPageOptions.map((opt) => (
          <option key={String(opt)} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    </div>
  );
};

export default PerPageSelector;
